import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl01 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".grey{fill:#646973;}.red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_01",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Signal",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M51,32h-12c-1.1,0-2-.9-2-2V10c0-.53.21-1.04.59-1.41l2.83-2.83c.38-.38.88-.59,1.41-.59h6.34c.53,0,1.04.21,1.41.59l2.83,2.83c.38.38.59.88.59,1.41v20c0,1.1-.9,2-2,2Z"
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "red",
						cx: 45,
						cy: 15,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "grey",
						cx: 42,
						cy: 21,
						r: 2
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "grey",
						cx: 48,
						cy: 21,
						r: 2
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Arrow",
				className: "black",
				d: "M55.92,46.38c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-5-5c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l3.29,3.29h-9.59c-.55,0-1,.45-1,1s.45,1,1,1h9.59l-3.29,3.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5-5c.09-.09.17-.2.22-.33Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "ICE_Sideview",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "red",
						d: "M37,52H12c-.55,0-1-.45-1-1s.45-1,1-1h25c.55,0,1,.45,1,1s-.45,1-1,1Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M28,56H12c-.55,0-1-.45-1-1s.45-1,1-1h16c9,0,9-2.52,9-4.03,0-2.39-2.66-5.91-6.62-8.76-4.56-3.41-9.63-5.21-14.69-5.21h-3.69c-.55,0-1-.45-1-1s.45-1,1-1h3.69c5.49,0,10.98,1.93,15.88,5.59,4.58,3.3,7.44,7.28,7.44,10.38,0,4.23-3.29,6.03-11,6.03Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M24.76,45.78s-.1,0-.15-.01l-.5-.07c-3.2-.47-6.48-.7-10.02-.7h-2.09c-.55,0-1-.45-1-1s.45-1,1-1h2.09c3.64,0,7.01.24,10.31.72h0l.94-.94c-3.08-1.82-6.66-2.78-10.34-2.78h-3c-.55,0-1-.45-1-1s.45-1,1-1h3c4.04,0,7.97,1.06,11.36,3.06l1.11.66c.27.16.44.43.48.74.04.31-.07.61-.29.83l-2.21,2.21c-.19.19-.44.29-.71.29Z"
					})
				]
			})
		]
	})]
});
export default SvgAppIcBefehl01;
